import InspirationCardMobile from "./Inspiration-card-mobile";
import InspirationCardWeb from "./Inspiration-card-web";


const InspirationCard = ({ item, onOpen }) => {
  if (item.platform === "Mobile") {
    return <InspirationCardMobile item={item} onOpen={onOpen} />;
  }

  return <InspirationCardWeb item={item} onOpen={onOpen} />;
};

export default InspirationCard;
